import { Module } from 'vuex';
import { IUIState } from './models/ui-state.model';
import { IRootState } from './models/root-state.model';
import { UIService } from '../services/ui-service/ui.service';

const UISvc = new UIService();
export const UIStateModule: Module<IUIState, IRootState> = {
  namespaced: true,
  state: () => ({}),
  getters: {
    gateEditEnabled(state: IUIState) {
      return UISvc.gateEditEnabled();
    },

    gateDeleteEnabled(state: IUIState) {
      return UISvc.gateDeleteEnabled();
    },

    roomEditEnabled(state: IUIState) {
      return UISvc.roomEditEnabled();
    },

    plantEditEnabled(state: IUIState) {
      return UISvc.plantEditEnabled();
    },

    roomConfigEnabled(state: IUIState) {
      return UISvc.roomConfigEnabled();
    },

    plantDeleteEnabled(state: IUIState) {
      return UISvc.plantDeleteEnabled();
    },

    plantAddRoomEnabled(state: IUIState) {
      return UISvc.plantAddRoomEnabled();
    },

    scenesActionsEnabled(state: IUIState) {
      return UISvc.scenesActionsEnabled();
    },

    plantEditListEnabled(state: IUIState) {
      return UISvc.plantEditListEnabled();
    },

    scenesAddSceneEnabled(state: IUIState) {
      return UISvc.scenesAddSceneEnabled();
    },

    plantDeleteListEnabled(state: IUIState) {
      return UISvc.plantDeleteListEnabled();
    },

    roomObjectDeleteEnabled(state: IUIState) {
      return UISvc.roomObjectDeleteEnabled();
    },

    plantInlineRenameEnabled(state: IUIState) {
      return UISvc.plantInlineRenameEnabled();
    },

    plantDeviceSettingsEditEnabled(state: IUIState) {
      return UISvc.plantDeviceSettingsEditEnabled();
    },

    plantServerUseMHS1Only(): boolean {
      return UISvc.plantServerUseMHS1Only();
    },

    plantC300EosSettingsEditEnabled(state: IUIState) {
      return UISvc.plantC300EosSettingsEditEnabled();
    },

    commandsAndGroupsAddGroupEnabled(state: IUIState) {
      return UISvc.commandsAndGroupsAddGroupEnabled();
    },

    commandsAndGroupsGroupActionsEnabled(state: IUIState) {
      return UISvc.commandsAndGroupsGroupActionsEnabled();
    },

    plantRoomObjectSettingsEditDialog(state: IUIState) {
      return UISvc.plantRoomObjectSettingsEditDialog();
    },

    devicesPageAddDeviceEnabled() {
      return UISvc.devicesPageAddDeviceEnabled();
    },

    devicesPageFilterZigbeeEnabled(): boolean {
      return UISvc.devicesPageFilterZigbeeEnabled();
    },

    plantEditImageCustomEnabled(): boolean {
      return UISvc.plantEditImageCustomEnabled();
    },

    profilePageEnabled(): boolean {
      return UISvc.profilePageEnabled();
    },
  },
};
